const LogoApplePay: React.FC<SVGProps<SVGSVGElement>> = () => (
  <svg
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 211"
    width="70"
    height="30"
  >
    <title>Apple_Pay_logo-svg</title>
    <path
      id="XMLID_34_"
      fill-rule="evenodd"
      className="s0"
      d="m93.6 27.1c-6 7.1-15.6 12.7-25.2 11.9-1.2-9.6 3.5-19.8 9-26.1 6-7.3 16.5-12.5 25-12.9 1 10-2.9 19.8-8.8 27.1zm39.7 30.6c-0.8 0.6-18.5 10.8-18.3 32.2 0.2 25.6 22.4 34.1 22.6 34.3-0.2 0.6-3.5 12.1-11.6 23.9-7.1 10.4-14.4 20.6-26 20.8-11.2 0.2-14.9-6.7-27.8-6.7-12.8 0-17 6.5-27.6 6.9-11.2 0.4-19.7-11-26.8-21.4-14.5-21-25.6-59.2-10.6-85 7.3-12.9 20.6-21 34.9-21.2 11-0.2 21.1 7.3 27.8 7.3 6.6 0 18.5-8.7 32.4-7.9 5.4 0.4 21 2 31 16.8zm107.8-45.8c30.2 0 51.3 20.8 51.3 51.2 0 30.4-21.5 51.4-52.1 51.4h-33.5v53.3h-24.2v-155.9zm-34.3 82.3h27.8c21.1 0 33.1-11.3 33.1-31 0-19.7-12-30.9-33-30.9h-27.9zm91.6 41.2c0-20 15.2-31.5 43.3-33.2l30.2-1.8v-8.6c0-12.7-8.3-19.6-23.1-19.6-12.2 0-21.1 6.3-22.9 15.9h-21.8c0.7-20.2 19.7-34.9 45.4-34.9 27.7 0 45.7 14.5 45.7 37v77.6h-22.4v-18.7h-0.5c-6.4 12.2-20.5 19.9-35.7 19.9-22.5 0-38.2-13.4-38.2-33.6zm73.5-9.9v-8.8l-26.9 1.7c-15.1 0.9-23 6.6-23 16.4 0 9.5 8.2 15.7 21.1 15.7 16.4 0 28.8-10.4 28.8-25zm44 84.1v-18.7c1.5 0.2 5.2 0.4 7.1 0.4 10.7 0 16.7-4.5 20.4-16.2l2.2-6.9-41-113.5h25.3l28.5 92.1h0.5l28.5-92.1h24.6l-42.5 119.2c-9.7 27.3-20.8 36.3-44.4 36.3-1.8 0-7.8-0.2-9.2-0.6z"
    />
    <g id="Layer"></g>
    <g id="Layer"></g>
    <g id="Layer"></g>
    <g id="Layer"></g>
    <g id="Layer"></g>
    <g id="Layer"></g>
  </svg>
);

export default LogoApplePay;
